'use client';

import { tsr } from '@/libs/ts-rest/ts-rest';
import { createJobGetQueryOptions } from '@/modules/job/contracts';
import type { JobGetQueryOptions } from '@/modules/job/contracts';

export const useJobGetQuery = (jobId: string, options?: Partial<JobGetQueryOptions>) => {
	const queryOptions = createJobGetQueryOptions(jobId);

	return tsr.jobs.findById.useQuery({
		...queryOptions,
		...options,
	});
};
